import { RouteRecordRaw } from "vue-router";

const Register = () =>
  import(
    /* webpackChunkName: "register" */ "@/views/auth/signup/RegisterIndex.vue"
  );
const RegisterStep1 = () =>
  import(/* webpackChunkName: "register" */ "@/views/auth/signup/StepOne.vue");
const RegisterStep2 = () =>
  import(/* webpackChunkName: "register" */ "@/views/auth/signup/Step2.vue");
const RegisterSuccess = () =>
  import(
    /* webpackChunkName: "register" */ "@/views/auth/signup/SuccessPage.vue"
  );

const routes: Array<RouteRecordRaw> = [
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: {
      title: "Join Now | Simply Broadband",
    },
  },
  {
    path: "/register/1",
    name: "step1",
    component: RegisterStep1,
    meta: {
      title: "Join Now | Simply Broadband",
    },
  },
  {
    path: "/register/2",
    name: "step2",
    component: RegisterStep2,
    meta: {
      title: "Join Now | Simply Broadband",
    },
  },
  {
    path: "/success",
    name: "success",
    component: RegisterSuccess,
    meta: {
      title: "Thank You | Simply Broadband",
    },
  },
];

const registerRoutes = routes;

export default registerRoutes;
